import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/i18n/messages';
import pluralizationRules from "@/i18n/pluralizationRules";

Vue.use(VueI18n);

export const getLocale = () => {
  if (typeof document === 'undefined') return 'ru';
  return document.documentElement.lang;
}

const i18n = new VueI18n({
  locale: getLocale(),
  messages,
  pluralizationRules
});

export default i18n;
